export const SPRING_CONFIG = { tension: 350, friction: 30 };

export const INITIAL_BALL_BOTTOM = 282;
export const INITIAL_BALL_LEFT = 84;
export const INITIAL_CONTAINER_LEFT = 0;
export const INITIAL_CONTAINER_SPEED = 20;

export const WINDOW_HEIGHT_LARGE = 640;
export const WINDOW_HEIGHT_MEDIUM = 580;
export const WINDOW_WIDTH_MOBILE = 500;

export const CONTAINER_HEIGHT_LARGE = 666;
export const CONTAINER_HEIGHT_SMALL = 560;
export const BLUE_LINE_OFFSET_LARGE = 350;
export const BLUE_LINE_OFFSET_SMALL = 280;

export const BIRD_WIDTH = 40;
export const BIRD_HEIGHT = 85;
export const BIRD_TOP_FAIL_OFFSET = 55;

export const CONTAINER_SHIFT_INTERVAL_MS = 100;
export const CONTAINER_SPEED_STEP = 0.05;
export const FALL_INTERVAL_MS = 50;
export const FALL_STEP = 12;

export const JUMP_OFFSET = 80;
export const ROTATE_UP_DEG = -10;
export const ROTATE_DOWN_DEG = 40;
export const ROTATE_DOWN_DELAY_MS = 300;
export const ENABLE_REPEAT_CLICK_DELAY_MS = 1000;
export const FIRST_CLICK_ANIMATION_DELAY_MS = 170;

export const FIRST_CLICK_BOOST_LARGE = 280;
export const FIRST_CLICK_BOOST_MEDIUM = 180;
export const FIRST_CLICK_BOOST_SMALL = 130;
export const FIRST_CLICK_SHIFT_LEFT_MOBILE = 20;
export const FIRST_CLICK_SHIFT_LEFT_DESKTOP = 100;

export const COLLISION_CHECK_LIMIT_X = 400;
export const SCORE_PASS_LIMIT_X = 154;
export const TOP_OBS_X_OFFSET = 20;
export const BOTTOM_OBS_X_OFFSET = -10;
export const BOTTOM_OBS_Y_OFFSET = 30;
export const TOP_OBS_Y_OFFSET = -10;

export const COLLISION_FAIL_DELAY_MS = 60;
export const TOP_BORDER_FAIL_DELAY_MS = 20;
export const FAIL_BALL_BOTTOM_OFFSET = 333;
export const FAIL_POPUP_DELAY_MS = 300;
